import styled from '@emotion/styled';
import { breakpoint, spacing } from '../../../../../../themes';

export const QuickRangeWrapper = styled.div`
  margin-right: ${spacing.small};
  /* margin-left: ${spacing.xsmall};
  margin-top: ${spacing.xsmall};
  margin-bottom: ${spacing.xsmall}; */
  padding-right: ${spacing.small};
  border-right: 1px solid #d6d7d9;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: ${spacing.xxsmall};

  @media (max-width: ${breakpoint.medium}px) {
    border-right: none;
    border-top: 1px solid #d6d7d9;
    padding: ${spacing.xmsmall} 0 0;
    margin: ${spacing.xmsmall} 0 0;
    align-items: center;
  }
`;
